document.addEventListener("DOMContentLoaded", function() {
  var titleWithFilter = document.querySelector('#main-collection-filters');
  var closeSearch = document.querySelector('.search-drawer__close.js-close-search-drawer');   
  var isScrollingDown = false;
  var lastScrollTop = 0;
  let collection_logo = document.querySelector('.collection-logo');
  let main_header__top = document.querySelector('.main-header__top');
  let facets = document.querySelector('.facets-container.facets-container-drawer');
  let closeButton = document.querySelector('.top-mobile-filter--container .close-filter')
  let detailsDtawer = document.querySelector('.mobile-facets__wrapper .mobile-facets__disclosure')

  function addClassOnScroll() {
    var scroll = window.pageYOffset;

    if (scroll > lastScrollTop) {
        isScrollingDown = true;
    } else {
        isScrollingDown = false;
    }      
    if (isScrollingDown && scroll > 65) {
        titleWithFilter?.classList.add("fixed_h1");
        if(window.matchMedia("(min-width: 768px)").matches) {
          collection_logo.classList.add('collection-logo--visible')
          main_header__top.style.display="none";
          facets.classList.add('fixed')
        }
    } else if(window.matchMedia("(min-width: 768px)").matches && !isScrollingDown){
          collection_logo.classList.remove('collection-logo--visible')
          main_header__top.style.display="flex";
          facets.classList.remove('fixed')
    }
    else if(scroll < 26){
      titleWithFilter.classList.remove("fixed_h1");
    }
    lastScrollTop = scroll;
  }
  

   window.addEventListener('scroll', addClassOnScroll);

  closeButton.addEventListener('click', function() {
      detailsDtawer.removeAttribute("open")
      document.body.classList.remove(`overflow-hidden`);
  })

  document.querySelectorAll('.collection_types .collection_type .link').forEach(el => {
      el.addEventListener('click', () => {
        filterProducts(el,el.dataset.type)
      });
  });
  document.querySelectorAll('.collection_types .collection_type .globalType').forEach(el => {
    el.addEventListener('click', () => {
      let types = [];
      filterProducts(el,types)
    });
});

  function filterProducts(el, types) {
    document.querySelectorAll(".collection_types .collection_type").forEach(el => {
      el.classList.remove('active');
    });
    if(typeof types !== 'object') {
      el.parentElement.classList.add('active')
    }
    else {
      document.querySelectorAll(`.collection_types .collection_type--image.link[data-globalType="${el.getAttribute('data-type')}"]`).forEach(link => {
        types.push(link.getAttribute('data-type'))
        link.closest('.collection_type').classList.add('active')
      })
    }
    let count = 0;
    document.querySelectorAll('.collection__content > li.product-item').forEach(el => {
      if (el.className && el.className.includes('d-none')) {
        el.classList.remove('d-none');
      }
      if (types !== 'all') {
        if(typeof types == 'object' ) {
          if(!types.includes(el.querySelector('.product-card__link').dataset.type)) {
            el.classList.add('d-none');
            document.querySelector('.collection__content').classList.add('data-filtred');
          }else{
            count++;
          }
        }else {
          if (el.querySelector('.product-card__link').dataset.type !== types){
            el.classList.add('d-none');
            document.querySelector('.collection__content').classList.add('data-filtred');
          }else{
            count++;
          }
        }
      } else {
        count++;
        document.querySelector('.collection__content').classList.remove('data-filtred');
      }
    });
  }

  // toggle chooseFit
  let = toggleChooseFit = document.querySelector('.toggleChooseFit');
  if(toggleChooseFit) {
      document.querySelector('.toggleChooseFit').addEventListener('click', () => {
          document.querySelector('.chooseFit-mobile .chooseFit-mobile--bloc').classList.toggle('show-chooseFit');
          document.querySelector('#FacetFiltersFormMobile').classList.toggle('chooseFit');
          document.querySelector('.chooseFit-mobile svg').classList.toggle('close');
      
          const maxHeight = document.querySelector('.chooseFit-mobile .collection_types').clientHeight + 50;
          document.querySelector('.chooseFit-mobile .chooseFit-mobile--bloc').style.maxHeight = '0px';
          document.querySelector('.chooseFit-mobile .chooseFit-mobile--bloc').style.opacity = '0';
          if (document.querySelector('.chooseFit-mobile .chooseFit-mobile--bloc').classList.contains('show-chooseFit')) {
              document.querySelector('.chooseFit-mobile .chooseFit-mobile--bloc').style.maxHeight = maxHeight + 'px';
              document.querySelector('.chooseFit-mobile .chooseFit-mobile--bloc').style.opacity = '1';
          }
      });
  }
  // check if the page filtred
  var currentUrl = window.location.href;
  if (currentUrl.includes("filter.") || (currentUrl.includes("sort_by") && !currentUrl.includes("sort_by=manual"))) {
    document.getElementById("product-grid").classList.add('data-filtred');
  }
});
